import { createAction } from '@reduxjs/toolkit';

export const setSuppressionIsBusy = createAction('setSuppressionIsBusy');
export const setSuppressionList = createAction('setSuppressionList');
export const setSuppressionLoading = createAction('setSuppressionLoading');
export const setSuppressionModal = createAction('setSuppressionModal');
export const setSuppressionName = createAction('setSuppressionName');
export const setEditingSuppression = createAction('setEditingSuppression');
export const setSuppressionProgress = createAction('setSuppressionProgress');
